import PropTypes from 'prop-types';
import { memo } from 'react';
// -*- mode: jsx;-*-
import { ProjectCost } from './ProjectCost.js';
import { hasMatch, makeStillNeededWithMatch as projectUtilsMakeStillNeededWithMatch } from './projectUtils.js';
import { projectFormatter } from './projectFormatter.js';


/**
 * The list of miscellaneous project facts used on the right side of a project card.
 */
export let ProjectDataList = function ({ project, incomplete, numDonors, hideExpiration, isEligibleForPrefunding, isTeacherOnlyView }) {
    function makeDonors() {
        if (numDonors > 0) {
            return (
                <li>
                    <span className="project-donors">{numDonors}</span> {numDonors === 1 ? 'donor' : 'donors'}
                    <span className="no-mobile"> so far</span>
                </li>
            );
        } else if (isEligibleForPrefunding) {
            return <li className="pre-funding">Friends and family pre-funding</li>;
        } else if (isTeacherOnlyView) {
            return <li className="no-donors">Inspire your first donation</li>;
        } else {
            return <li className="no-donors">Be the first to support this project</li>;
        }
    }

    function makeCost() {
        if (!isEligibleForPrefunding) {
            return <li className="project-cost-container"><ProjectCost project={project} /></li>;
        }
    }

    function makeExpiration() {
        if (!hideExpiration &&
                project.fundingStatus === 'needs funding' &&
                projectFormatter.expiresSoon(project.expirationDate)) {
            return (
                <li className="expiring-soon"
                    dangerouslySetInnerHTML={{ __html: projectFormatter.daysLeft(project.expirationTime) }}>
                </li>
            );
        }
    }

    function makePrefundingInfo() {
        if (isEligibleForPrefunding) {
            return (
                <li className="instant-fundraising-explanation">
                    Donations will appear on this project once the project is approved by our team.
                </li>
            );
        }
    }

    function makeStillNeededWithMatch() {
        if (hasMatch(project)) {
            return (
                <li className="desktop matched-amount">
                    <strong><span>{projectUtilsMakeStillNeededWithMatch(project)}</span> </strong>
                    <span> for now</span>
                </li>
            );
        } else {
            return null;
        }
    }

    return (
        <ul className="project-data js-project-data">
            {incomplete ? '' : <li className="completed">Fully funded!</li> }
            {makeCost()}
            {makeDonors()}
            {makeExpiration()}
            {makePrefundingInfo()}
            {makeStillNeededWithMatch()}
        </ul>
    );
};

ProjectDataList.propTypes = {
    project: PropTypes.object.isRequired,
    incomplete: PropTypes.bool.isRequired,
    numDonors: PropTypes.number.isRequired,
    hideExpiration: PropTypes.bool,
    isEligibleForPrefunding: PropTypes.bool,

    // True if this card is on a page that only the teacher will see (like
    // teacher hub).
    isTeacherOnlyView: PropTypes.bool,
};

ProjectDataList = memo(ProjectDataList);
